import React from "react";

import { MdmObject } from "gql/generated/types";
import { InputTextarea } from "primereact/inputtextarea";

type ObjectNotesProps = {
  object: MdmObject
}

const ObjectNotes: React.FC<ObjectNotesProps> = ({ object }) => {
  
  return (
    <InputTextarea  rows={5}/>
  )
}

export default ObjectNotes;